import { render, staticRenderFns } from "./BasicMannersCard.vue?vue&type=template&id=10746125&scoped=true&"
import script from "./BasicMannersCard.vue?vue&type=script&lang=js&"
export * from "./BasicMannersCard.vue?vue&type=script&lang=js&"
import style0 from "./BasicMannersCard.vue?vue&type=style&index=0&id=10746125&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10746125",
  null
  
)

export default component.exports